import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { CarePlanTemplatesApi } from '../../../apis/CarePlanTemplatesApi/CarePlanTemplatesApi.ts';
import {
  ICarePlanTemplate,
  ICarePlanTemplateInput,
} from '../CarePlanTemplate.ts';

export function useCreateCarePlanTemplate() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<ICarePlanTemplate, AppMedError, ICarePlanTemplateInput>({
    mutationKey: [QueryKeys.carePlanTemplates, 'create'],
    mutationFn: (input) => CarePlanTemplatesApi.post(input),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.carePlanTemplates],
      });
      notifications.show({
        color: 'teal',
        message: t('carePlan.notifications.created'),
      });
    },
    onError: (error) => {
      notifications.show({
        color: 'red',
        message: error?.message || t('carePlan.notifications.createError'),
      });
    },
  });
}
